import ABadge from './Badge';
export default ABadge;


// WEBPACK FOOTER //
// ./src/packages/Badge/index.js